import { render } from "./FooterHero.vue?vue&type=template&id=43fadeea&scoped=true"
const script = {}

import "./FooterHero.vue?vue&type=style&index=0&id=43fadeea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fadeea"]])

export default __exports__